import { of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class NursingHomeChatService {
  constructor(private http: HttpService) {
  }

  download(nursingHomeId = null, fileName = null): Observable<Blob> {
    if (!fileName) return;

    let params: { [key: string]: any } = {};
    if (fileName) {
      params = {...params, fileName: fileName};
    }

    return this.http.getBlob
      ('/api/v2/pro/nursing-homes/' + nursingHomeId + '/chats/files/download', params);
  }

}
